import MDPhoneInput from "../components/Inputs/MDPhoneInput";
import { Form, Formik } from "formik";
import MDTextInput from "../components/Inputs/MDTextInput";
import MDSelectInput from "../components/Inputs/MDSelect";
import MDDateAndTimePicker from "../components/Inputs/MDDateAndTimePicker";
import AutoFocusError from "../components/AutoFocusError";
import { SellerStep1Schema, SellerStep5Schema } from "../validations";
import { useState, useRef } from "react";
import {
  basementOptions,
  sellerBathOptions,
  sellerBedOptions,
  condoStyleOptions,
  condoTownhouseStyleOptions,
  detachedOrSemidetachedStyleOptions,
  garageOptions,
  homeAgeOptions,
  homeConditionOptions,
  homeTypeOptions,
  movingTimelineOptions,
  priceRangeOptions,
  sqftOptions,
  upgradesOptions,
  workingWithOtherAgentOptions,
  genericLookingForOptions,
  genericSellerMeetingOptions,
} from "../utils/enum";
import axios from "axios";
import { useLocation } from "react-router";
import dayjs from "dayjs";
import MDAutoComplete from "../components/Inputs/MDAutoComplete";
import StartSellingHomeThanks from "../components/ThanksUser/StartSellingHomeThanks";
import { config } from "../utils/config";

const StartSellingHomeForm = ({ isMultiPartForm }) => {
  const typingTimeout = useRef(null);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [currentStep, setCurrentStep] = useState(isMultiPartForm ? 2 : 1);
  const [isWhatsApp, setIsWhatsApp] = useState(false);
  const [addressOptions, setAddressOptions] = useState([]);
  const [phoneBtnClick, setPhoneBtnClick] = useState(false);
  const [submitError, setSubmitError] = useState(false);
  const windowUrl = window.location.href;

  const userAddress = queryParams.get("address");
  const marketingSource = queryParams.get("source");

  const handleAddressChange = async (event, value) => {
    const inputValue = value.trimStart();
    if (inputValue.length > 0) {
      if (typingTimeout.current) {
        clearTimeout(typingTimeout.current);
      }

      typingTimeout.current = setTimeout(async () => {
        try {
          const headers = {
            "Content-Type": "application/json",
          };

          const response = await axios.get(
            `https://cn.chishtiglobal.ca/api/Data/AddressResponse/${value}`,
            headers
          );

          if (response?.data?.result === 1) {
            const filteredCities = response?.data?.data?.map((item) => {
              return {
                responseTitle: item.responseTitle,
                responseDesc: item.responseDesc,
              };
            });
            setAddressOptions(filteredCities);
          }
        } catch (error) {
          console.log(error);
        }
      }, 300);
    }
  };

  const initialValues = {
    name: "",
    email: "",
    phone: "",
    streetaddress: "",
    lookingFor: "",
    workingWithOtherAgent: "",
    movingTimeLine: "",
    homeType: "",
    homeStyle: "",
    sqft: "",
    priceRange: "",
    bed: "",
    bath: "",
    garage: "",
    basementCondition: "",
    upgrades: "",
    homeAge: "",
    homeCondition: "",
    otherThings: "",
    meetingOpinion: "",
    meetingTime: null,
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setSubmitError(false);

    if (currentStep === 6) {
      resetForm({ values: initialValues, submitCount: 0 });
      setCurrentStep(1);
      return;
    }

    try {
      const data = {
        ...values,
        meetingTime: dayjs(values?.meetingTime).format(
          "YYYY-MM-DDTHH:mm:ss.SSS"
        ),
        address: userAddress || "",
        originUrl: windowUrl,
        category: "SellerGeneric",
        formType: config?.platformTitle || "",
        marketingSource: marketingSource || "",
      };
      const response = await axios.post(
        "https://cn.chishtiglobal.ca/formconnector/sale2solddefault",
        data
      );
      if (response?.data?.result === 1) {
        window.scrollTo(0, 0);
        setCurrentStep(currentStep + 1);
        setSubmitError(false);

        if (isWhatsApp) {
          window.open(
            `https://api.whatsapp.com/send?phone=${
              config?.platformWhatsAppNumber
            }&amp;text=Hey ${config?.platformTitle}, My Name is ${
              values?.name || ""
            }. I am looking to Sell. Can you connect with me As soon as possible.`,
            "_blank"
          );
        }

        if (phoneBtnClick) {
          window.location.href = "tel:+16476490400";
        }
      } else {
        setSubmitError(true);
      }
    } catch (error) {
      setSubmitError(true);
      console.error(error);
    } finally {
      setIsWhatsApp(false);
      setPhoneBtnClick(false);
      setSubmitting(false);
      resetForm({ values, submitCount: 0 });
    }
  };

  return (
    <div className="form_mainContainer">
      <div className="agent_profile d-flex align-items-center gap-3">
        <img
          src="https://config.assignmentsold.ca/Attachments/Newhomez-Agent-Profile.jpg"
          alt="Agent-Profle"
        />
        <div>
          <h3 className="agent_name m-0">
            {config?.platformTitle || "Sale2Sold"}
          </h3>
          <p className="agent_category">Listing Agent</p>
        </div>
      </div>
      <div className="form_container">
        <Formik
          initialValues={initialValues}
          validationSchema={
            currentStep === 1
              ? SellerStep1Schema
              : currentStep === 5
              ? SellerStep5Schema
              : null
          }
          onSubmit={handleSubmit}
        >
          {({
            isSubmitting,
            errors,
            handleChange,
            handleBlur,
            values,
            submitCount,
            submitForm,
            setFieldValue,
          }) => (
            <Form className="w-100 gap-3 mt-4 d-flex flex-column">
              <AutoFocusError />

              {currentStep === 1 && (
                <>
                  <MDTextInput
                    label="Enter Your Name"
                    name="name"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={submitCount > 0 && Boolean(errors.name)}
                    helperText={submitCount > 0 && errors.name}
                    fullWidth
                  />
                  <MDTextInput
                    label="Enter Your Email"
                    name="email"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={submitCount > 0 && Boolean(errors.email)}
                    helperText={submitCount > 0 && errors.email}
                    fullWidth
                  />
                  <MDPhoneInput
                    name="phone"
                    value={values.phone}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={submitCount > 0 && Boolean(errors.phone)}
                    helperText={submitCount > 0 && errors.phone}
                    fullWidth
                  />
                </>
              )}

              {currentStep === 2 && (
                <>
                  <div>
                    <p className="label_heading">What's your Street Address?</p>
                    <MDAutoComplete
                      options={addressOptions?.map((b) => b?.responseDesc)}
                      value={values.streetaddress}
                      onChange={(event, newValue) => {
                        setFieldValue("streetaddress", newValue);
                      }}
                      onInputChange={handleAddressChange}
                      error={submitCount > 0 && Boolean(errors.streetaddress)}
                      helperText={submitCount > 0 && errors.streetaddress}
                      label="Enter Street Address"
                      fullWidth
                    />
                  </div>

                  <div>
                    <p className="label_heading">I am looking to</p>
                    <MDSelectInput
                      label="Select"
                      name="lookingFor"
                      value={values.lookingFor}
                      options={genericLookingForOptions}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={submitCount > 0 && Boolean(errors.lookingFor)}
                      helperText={submitCount > 0 && errors.lookingFor}
                      fullWidth
                    />
                  </div>

                  <div>
                    <p className="label_heading">
                      Are you working with another realtor under a Listing /
                      Representation Agreement?
                    </p>
                    <MDSelectInput
                      label="Select"
                      name="workingWithOtherAgent"
                      value={values.workingWithOtherAgent}
                      options={workingWithOtherAgentOptions}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        submitCount > 0 && Boolean(errors.workingWithOtherAgent)
                      }
                      helperText={
                        submitCount > 0 && errors.workingWithOtherAgent
                      }
                      fullWidth
                    />
                  </div>

                  <div>
                    <p className="label_heading">
                      Do you know when you're looking to move?
                    </p>
                    <MDSelectInput
                      label="Select"
                      name="movingTimeLine"
                      value={values.movingTimeLine}
                      options={movingTimelineOptions}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={submitCount > 0 && Boolean(errors.movingTimeLine)}
                      helperText={submitCount > 0 && errors.movingTimeLine}
                      fullWidth
                    />
                  </div>
                </>
              )}

              {currentStep === 3 && (
                <>
                  <div>
                    <p className="label_heading">
                      What type of home do you own?
                    </p>
                    <MDSelectInput
                      label="Select"
                      name="homeType"
                      value={values.homeType}
                      options={homeTypeOptions}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={submitCount > 0 && Boolean(errors.homeType)}
                      helperText={submitCount > 0 && errors.homeType}
                      fullWidth
                    />
                  </div>

                  {values?.homeType && values?.homeType !== "Other" && (
                    <div>
                      <p className="label_heading">What’s your Home’s Style?</p>
                      <MDSelectInput
                        label="Select"
                        name="homeStyle"
                        value={values.homeStyle}
                        options={
                          values?.homeType === "Condo"
                            ? condoStyleOptions
                            : values?.homeType === "Condo Town"
                            ? condoTownhouseStyleOptions
                            : values?.homeType === "Townhouse"
                            ? condoTownhouseStyleOptions
                            : detachedOrSemidetachedStyleOptions
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={submitCount > 0 && Boolean(errors.homeStyle)}
                        helperText={submitCount > 0 && errors.homeStyle}
                        fullWidth
                      />
                    </div>
                  )}

                  <div>
                    <p className="label_heading">
                      How Many square feet is your Home not including any
                      basement or balcony space?
                    </p>
                    <MDSelectInput
                      label="Select"
                      name="sqft"
                      value={values.sqft}
                      options={sqftOptions}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={submitCount > 0 && Boolean(errors.sqft)}
                      helperText={submitCount > 0 && errors.sqft}
                      fullWidth
                    />
                  </div>

                  <div>
                    <p className="label_heading">
                      Do you have a Price Range in mind for your home?
                    </p>
                    <MDSelectInput
                      label="Select"
                      name="priceRange"
                      value={values.priceRange}
                      options={priceRangeOptions}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={submitCount > 0 && Boolean(errors.priceRange)}
                      helperText={submitCount > 0 && errors.priceRange}
                      fullWidth
                    />
                  </div>

                  <div>
                    <p className="label_heading">
                      How Many Beds does your Home Have?
                    </p>
                    <MDSelectInput
                      label="Select"
                      name="bed"
                      value={values.bed}
                      options={sellerBedOptions}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={submitCount > 0 && Boolean(errors.bed)}
                      helperText={submitCount > 0 && errors.bed}
                      fullWidth
                    />
                  </div>

                  <div>
                    <p className="label_heading">
                      How many Bathrooms does your Home Have?
                    </p>
                    <MDSelectInput
                      label="Select"
                      name="bath"
                      value={values.bath}
                      options={sellerBathOptions}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={submitCount > 0 && Boolean(errors.bath)}
                      helperText={submitCount > 0 && errors.bath}
                      fullWidth
                    />
                  </div>
                </>
              )}

              {currentStep === 4 && (
                <>
                  <div>
                    <p className="label_heading">
                      How many Garages does your Home have?
                    </p>
                    <MDSelectInput
                      label="Select"
                      name="garage"
                      value={values.garage}
                      options={garageOptions}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={submitCount > 0 && Boolean(errors.garage)}
                      helperText={submitCount > 0 && errors.garage}
                      fullWidth
                    />
                  </div>
                  <div>
                    <p className="label_heading">
                      Does your home have a finished basement?
                    </p>
                    <MDSelectInput
                      label="Select"
                      name="basementCondition"
                      value={values.basementCondition}
                      options={basementOptions}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        submitCount > 0 && Boolean(errors.basementCondition)
                      }
                      helperText={submitCount > 0 && errors.basementCondition}
                      fullWidth
                    />
                  </div>
                  <div>
                    <p className="label_heading">
                      Does you home have any upgrades that you did after you
                      moved in?
                    </p>
                    <MDSelectInput
                      label="Select"
                      name="upgrades"
                      value={values.upgrades}
                      options={upgradesOptions}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={submitCount > 0 && Boolean(errors.upgrades)}
                      helperText={submitCount > 0 && errors.upgrades}
                      fullWidth
                    />
                  </div>
                  <div>
                    <p className="label_heading">
                      What is the condition of your home?
                    </p>
                    <MDSelectInput
                      label="Select"
                      name="homeCondition"
                      value={values.homeCondition}
                      options={homeConditionOptions}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={submitCount > 0 && Boolean(errors.homeCondition)}
                      helperText={submitCount > 0 && errors.homeCondition}
                      fullWidth
                    />
                  </div>
                  <div>
                    <p className="label_heading">
                      What is the approximate Age of your Home?
                    </p>
                    <MDSelectInput
                      label="Select"
                      name="homeAge"
                      value={values.homeAge}
                      options={homeAgeOptions}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={submitCount > 0 && Boolean(errors.homeAge)}
                      helperText={submitCount > 0 && errors.homeAge}
                      fullWidth
                    />
                  </div>
                  <div>
                    <p className="label_heading">
                      Do you know of any other things you think we should know?
                    </p>
                    <MDTextInput
                      label="Enter here"
                      name="otherThings"
                      value={values.otherThings}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={submitCount > 0 && Boolean(errors.otherThings)}
                      helperText={submitCount > 0 && errors.otherThings}
                      fullWidth
                      multiline
                      rows={3}
                    />
                  </div>
                </>
              )}

              {currentStep === 5 && (
                <>
                  <div>
                    <p className="label_heading">Let's set up a time to talk</p>
                    <MDSelectInput
                      label="Select"
                      name="meetingOpinion"
                      value={values.meetingOpinion}
                      options={genericSellerMeetingOptions}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={submitCount > 0 && Boolean(errors.meetingOpinion)}
                      helperText={submitCount > 0 && errors.meetingOpinion}
                      fullWidth
                    />
                  </div>
                  <MDDateAndTimePicker
                    label="Choose Date and Time"
                    value={values?.meetingTime}
                    onChange={(newValue) => {
                      setFieldValue("meetingTime", newValue);
                    }}
                    error={submitCount > 0 && Boolean(errors.meetingTime)}
                    helperText={submitCount > 0 && errors.meetingTime}
                  />
                </>
              )}

              {currentStep === 6 && (
                <StartSellingHomeThanks
                  userName={values.name}
                  phoneNumber={values.phone}
                  dateTime={values.meetingTime}
                />
              )}

              {submitError && (
                <p className="error_message m-0">
                  Error Submiting Form. Kindly submit again۔
                </p>
              )}

              <div
                className="w-100 d-flex align-item gap-3
              flex-wrap"
              >
                <button
                  type="submit"
                  className={`submit_button next_button ${
                    isSubmitting ? "disabled_btn" : ""
                  } ${currentStep === 5 ? "mbl_nextbtn" : ""} ${
                    currentStep === 6 ? "w-100" : ""
                  }`}
                  disabled={isSubmitting}
                >
                  {currentStep === 7
                    ? "Submit"
                    : currentStep === 6
                    ? "Lets talk about Lead’s Referral Rewards"
                    : currentStep === 5
                    ? "Let’s Get Connected"
                    : "Next"}
                </button>

                {currentStep !== 6 && (
                  <button
                    type="button"
                    className={`submit_button call_button 
                       ${isSubmitting ? "disabled_btn" : ""}
                      ${currentStep === 5 ? "mbl_callbtn" : ""}`}
                    disabled={isSubmitting}
                    onClick={() => {
                      submitForm();
                      setPhoneBtnClick(true);
                    }}
                  >
                    Call
                  </button>
                )}
              </div>

              {currentStep !== 6 && (
                <button
                  className={`Send_btn whatsApp_btn  ${
                    isSubmitting ? "disabled_btn" : ""
                  }`}
                  id="whatsApp_btn"
                  type="button"
                  disabled={isSubmitting}
                  onClick={() => {
                    setIsWhatsApp(true);
                    submitForm();
                  }}
                >
                  <img
                    src="https://config.assignmentsold.ca/attachments/newhomez-email/logos_whatsapp-icon.png"
                    alt="whatsapp_logo"
                  />
                  WhatsApp
                </button>
              )}
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default StartSellingHomeForm;
